import type { ValidationMetadata } from '../../types/analysis.types';
import { now } from './common';

export const vibeMapperValidation: ValidationMetadata = {
  groundingScore: 0.91,
  categoryConfidence: {
    'source-control': 0.88,
    build: 0.95,
    testing: 0.88,
    deployment: 0.96,
    security: 0.9,
    collaboration: 0.82,
    documentation: 0.93,
    'ai-tooling': 0.75,
  },
  issueCount: 8,
  warningCount: 7,
  correctionCount: 2,
  validatedAt: now,
};
